import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ListChecks, Columns3, ArrowLeft } from "lucide-react";
import { Card, CardContent } from "../../components/ui";

export const OperationSettingsHub: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const options = [
    {
      icon: ListChecks,
      title: "Vendas, Checklist e Tarefas",
      description: "Configure etapas de vendas, checkpoints, checklist e tarefas do fluxo",
      path: "/settings/operation/pipeline",
      color: "text-accent bg-accent/10",
    },
    {
      icon: Columns3,
      title: "Esteira de Preparação",
      description: "Defina baias, responsáveis por coluna e checklists da preparação",
      path: "/settings/operation/preparation",
      color: "text-accent bg-accent/10",
    },
  ];

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <div className="flex items-center gap-4">
        <button
          onClick={() => navigate("/settings")}
          className="p-2 hover:bg-accent/10 rounded-lg transition-colors"
        >
          <ArrowLeft className="h-5 w-5 text-muted-foreground" />
        </button>
        <div>
          <h1 className="text-2xl font-bold text-foreground">
            Configurações de Operação
          </h1>
          <p className="mt-1 text-sm text-muted-foreground">
            Configure checklist, tarefas e esteira de preparação
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {options.map((option) => {
          const Icon = option.icon;
          return (
            <Card
              key={option.path}
              className="cursor-pointer hover:shadow-lg transition-shadow group"
              onClick={() => navigate(option.path)}
            >
              <CardContent className="p-6">
                <div className="flex items-start space-x-4">
                  <div className={`p-3 rounded-xl ${option.color}`}>
                    <Icon className="h-6 w-6" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-foreground group-hover:text-accent transition-colors">
                      {option.title}
                    </h3>
                    <p className="text-sm text-muted-foreground mt-1">
                      {option.description}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
